import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "./App";
import images2 from "./images/logo.png";
import "bootstrap/dist/js/bootstrap.bundle.min";

export function TheNavbar() {
  const { currentUser, signOut } = useContext(AuthContext);

  return (
    <nav className="navbar navbar-expand-lg custom-navbars">
      <div className="container-fluid">
        {/* Logo and toggle button */}
        <Link className="navbar-brand" to="/">
          <img
            src={images2}
            width="40"
            height="40"
            className="d-inline-block align-top"
            alt="logo"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation items */}
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/quiz">
                Quiz
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/search">
                Explore Majors
              </Link>
            </li>
            {currentUser && (
              <li className="nav-item">
                <Link className="nav-link" to="/profile">
                  Profile
                </Link>
              </li>
            )}
          </ul>
          {currentUser ? (
            <button className="btn btn-outline-success" onClick={signOut}>
              Sign Out
            </button>
          ) : (
            <Link className="btn button-back" to="/signin">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
